import React from 'react';

// @mui/material components
import { makeStyles } from '@mui/styles';
// @mui/icons-material
import ParametersIcon from '@mui/icons-material/FormatListBulleted';

// core components
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import ReactTable from 'components/ReactTable/ReactTable.js';

import { secondaryColor } from '@themes/defaultThemeProps';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { useGetParameterDictionaryQuery } from 'api/parameter.api';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
  parameterName: {
    color: secondaryColor[2],
    fontWeight: '600',
    valign: 'top',
  },
  parameterDescription: {
    display: 'block',
    color: secondaryColor[0],
    fontWeight: '300',
  },
};

const useStyles = makeStyles(styles);

export default function ParameterDictionary() {
  const { data: parameterDictionary } = useGetParameterDictionaryQuery();

  const [data, setData] = React.useState(
    parameterDictionary.map((entry, key) => {
      const parameterRow = {
        id: key,
        category: entry.category,
        parameter: { name: entry.name, description: entry.description },
        default: entry.default,
      };
      return parameterRow;
    })
  );
  const classes = useStyles();

  const formatParameterCell = ({ value }) => {
    return (
      <div>
        <span className={classes.parameterName}>{value.name}</span>
        <span className={classes.parameterDescription}>
          {value.description}
        </span>
      </div>
    );
  };

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color='primary' icon>
            <CardIcon color='primary'>
              <ParametersIcon />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Parameter Defaults</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              columns={[
                {
                  Header: 'Category',
                  accessor: 'category',
                  disableSortBy: true,
                  width: 100,
                },
                {
                  Header: 'Parameter',
                  accessor: 'parameter',
                  Cell: formatParameterCell,
                  filter: 'parameter',
                  disableSortBy: true,
                  width: 200,
                },
                {
                  Header: 'Default Value',
                  accessor: 'default',
                  disableFilters: true,
                  disableSortBy: true,
                  width: 150,
                  style: {
                    marginBottom: 20,
                  },
                },
              ]}
              data={data}
              options={{
                pageSize: data.length,
              }}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
